<footer *ngIf="visible$ | async" class="footer" fxLayout="row" fxLayoutAlign="space-between center" role="contentinfo"
  aria-label="Application footer">
  <!-- Left: Privacy Policy -->
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxFlex="grow">
    <span>
      <a href="https://prep.continualengine.com/privacy-policy/" target="_blank" rel="noopener noreferrer"
        style="text-decoration: underline;" aria-label="Read our Privacy Policy (opens in a new tab)">
        {{ LangTextData.htmlLabel.privacyPolicy }}
      </a>
    </span>
  </div>
  <!-- Center: Attribution -->
  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" fxFlex="grow">
    <span aria-label="Powered by Continual Engine"> {{ LangTextData.htmlLabel.poweredBy }}</span>
  </div>
  <!-- Right: Close Button -->
  <div fxLayout="row" fxLayoutAlign="start center">
    <button (click)="hide()" mat-icon-button type="button" aria-label="Close footer" title="Close footer" 
        matTooltip="Close"
        matTooltipClass="table_tooltip_job_filename" matTooltipPosition="below">
      <mat-icon aria-hidden="true" class="close">close</mat-icon>
    </button>
  </div>
</footer>